import { css } from '@emotion/react'
import { breakpoints, container, font, radius } from '~/base'

export const wrapper = css`
  margin-bottom: 200px;
`

export const header = css`
  display: flex;
  justify-content: space-between;
  padding-top: 24px;
  flex-direction: column;
  margin-bottom: 24px;

  @media ${breakpoints.small} {
    padding-top: 44px;
    flex-direction: row-reverse;
  }

  @media ${breakpoints.large} {
    margin-bottom: -28px;
  }
`

export const headerBrand = css`
  margin-bottom: 24px;

  @media ${breakpoints.large} {
    margin-bottom: 0;
  }
`

export const headerAction = css`
  ${font({ size: 'small' })}
  color: #a0a0a0;

  @media ${breakpoints.small} {
    padding-top: 22px;
  }

  @media ${breakpoints.large} {
    padding-top: 0;
  }
`

export const logo = css`
  display: block;
  height: 80px;
  margin-left: auto;

  @media ${breakpoints.large} {
    height: 104px;
  }
`

export const actionIcon = css`
  height: 30px;
`

export const title = css`
  text-align: center;
  margin: 60px 0;
`

export const masterImage = css`
  ${radius('medium')}
  display: block;
  width: 100%;
  height: auto;
`

export const thumbImage = css`
  ${radius('xsmall')}
  display: block;
  width: 100%;
  height: auto;
  cursor: pointer;
  transition: all 0.25s ease;
  object-fit: cover;
`

export const slider = css`
  ${container({ padding: true })}
  margin-left: auto;
  margin-right: auto;

  .swiper {
    width: 100%;
    height: 100%;
  }

  /** Swiper: Master */

  .swiperMaster {
    ${radius('medium')}
  }

  /** Swiper: Thumbs */

  .swiperThumbs {
    margin-top: 16px;

    @media (min-width: 1024px) {
      margin-top: 36px;
    }
  }

  .swiperThumbs .swiper-slide {
    width: 20%;
    height: 100%;
  }

  .swiperThumbs .swiper-slide img {
    border: 4px solid #fff;
  }

  .swiperThumbs .swiper-slide-thumb-active img {
    // box-shadow: 0 0 0 4px var(--colors-primary);
    border: 4px solid var(--colors-primary);
  }
`

/** Arrows */

export const arrows = css`
  margin-bottom: 20px;
  color: var(--colors-primary);

  @media (min-width: 1024px) {
    margin-bottom: 40px;
  }
`

export const arrowsContent = css`
  ${container()}
  display: flex;
  justify-content: space-between;
`

export const arrowButton = css`
  margin: 0;
  padding: 0;
  background: transparent;
  border: none;
  font-size: inherit;
  color: inherit;
  cursor: pointer;

  &.swiper-button-disabled {
    opacity: 0.4;
  }
`

export const arrowIcon = css`
  height: 30px;
  width: auto;
  display: block;

  @media ${breakpoints.xsmall} {
    height: 36px;
  }
`
